import { Component, computed, input } from '@angular/core';
import { IbanFormatterPipe } from '../../pipes/iban-formatter/iban-formatter.pipe';

@Component({
  selector: 'ez-bank-account-info',
  imports: [IbanFormatterPipe],
  templateUrl: './bank-account-info.component.html',
  styleUrl: './bank-account-info.component.scss',
})
export class BankAccountInfoComponent {
  readonly iban = input.required<string>();
  readonly customerName = input.required<string>();
  readonly logoUrl = input<string>();
  readonly companyName = input<string>();

  readonly altText = computed(() => `Firmenlogo ${this.companyName()}`);
}
